import { Controller } from "stimulus";
import Cookies from "js-cookie";

const SUPPRESS_GPS_SEARCH_CONFIRM_COOKIE = "suppressGpsSearchConfirm";

/**
 * Lives on #fastModal for "My location" confirmation. Dispatches to the map
 * controller (which listens on window) then dismisses the modal.
 */
export default class extends Controller {
  confirm(evt) {
    evt.preventDefault();
    const suppressCheckbox = document.getElementById("dontShowGpsSearchConfirmAgain");
    if (suppressCheckbox && suppressCheckbox.checked) {
      Cookies.set(SUPPRESS_GPS_SEARCH_CONFIRM_COOKIE, "1", { expires: 365, path: "/" });
    }
    window.dispatchEvent(new CustomEvent("map:myLocationConfirmed"));
    window.dispatchEvent(new CustomEvent("dismiss-local-modal"));
  }
}
